import { TextFieldWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';
import _ = require('underscore');
import { SignInLogo } from '../../../app/spaces/Login/SignInLogo';
import { Messages } from '../../../codegen/Localize';
import { ISiteNameSansId } from '../../../ts/ServerApi/types/ISiteNameSansId';
import { SiteSwitchService } from '../../../ts/siteManagement/services/SiteSwitchService';
import { LoginSitePicker } from './LoginSitePicker';


const selectSite = (siteName: ISiteNameSansId) => {
  if (siteName) {
    const siteUrl: string = siteName.urlName;
    SiteSwitchService.switchIfNeededAndRedirectToStartPage(siteUrl);
  }
};

export function LoginSitePickerComponent(): JSX.Element {

  function renderSitePicker(): JSX.Element {
    const pickerProps = {
      handleSelectSiteOption: (siteName: ISiteNameSansId) => {
        selectSite(siteName);
      }
    };
    return (
      <LoginSitePicker {...pickerProps} />
    );
  }

  return (
    <div className="tb-login tb-login-site-picker-container">
      <SignInLogo />
      <div className="tb-login-title" id="textbox-sitepicker-label" data-tb-test-id='login-site-picker-title'>
        {Messages.selectASite()}
      </div>
      <div className="tb-login-site-picker">
        {renderSitePicker()}
      </div>
    </div>
  );
}